import { createTheme } from "@mui/material/styles";
import type {} from "@mui/x-data-grid/themeAugmentation";

import { buildAdminThemeOptions } from "./adminThemeConfig";

/**
 * Admin theme (visual alignment layer)
 *
 * Goal: make the internal admin portal feel cohesive with the customer app
 * (brand colors / typography / surfaces) while keeping admin layouts dense
 * and workflow-first.
 *
 * Note: we intentionally mirror the customer app’s tokens, but do NOT import
 * from `HelloCashflowApp/` to avoid cross-repo coupling.
 */
export const createAdminTheme = (mode: "light" | "dark" = "light") =>
    createTheme(buildAdminThemeOptions(mode));

// Type augmentation for custom theme properties
declare module "@mui/material/styles" {
    interface Theme {
        custom: {
            sidebar: {
                width: number;
                collapsedWidth: number;
            };
            header: {
                height: number;
            };
            layout: {
                contentPadding: number;
                sectionSpacing: number;
            };
        };
    }

    interface ThemeOptions {
        custom?: {
            sidebar?: {
                width?: number;
                collapsedWidth?: number;
            };
            header?: {
                height?: number;
            };
            layout?: {
                contentPadding?: number;
                sectionSpacing?: number;
            };
        };
    }
}

declare module "@mui/material/Button" {
    interface ButtonPropsVariantOverrides {
        ghost: true;
    }
}

declare module "@mui/material/Chip" {
    interface ChipPropsVariantOverrides {
        status: true;
    }
}
